/**
 * 契約作成モーダルの `related_lawyer_ids` 初期値ロジック (86eya0dva PR4)。
 *
 * 営業アクションからの契約作成では `participant_lawyer_ids` を初期値にし、
 * 商談を選ぶとその `related_lawyer_ids` を union + 重複排除で足し込む。
 * 商談の related が空配列の場合は「追加なし」であり、base を明示的にクリアする
 * 意味には解釈しない。
 */
export function mergeRelatedLawyerIds(
  base: string[],
  opportunityRelatedLawyerIds: string[],
): string[] {
  if (opportunityRelatedLawyerIds.length === 0) return base;
  const seen = new Set<string>();
  const out: string[] = [];
  for (const id of [...base, ...opportunityRelatedLawyerIds]) {
    if (seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}
